import { Button, createStyles, withStyles } from '@material-ui/core';
var style = createStyles({
  root: {
    backgroundColor: '#e45959',
    '&:hover': {
      backgroundColor: '#d75454'
    },
    '&:active': {
      backgroundColor: '#c85454'
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)'
    }
  }
});
export default withStyles(style, {
  name: 'DangerButton'
})(Button);